import { Stack, Tab, Tabs } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link, Outlet, redirect, useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import {
  getDailyFaresQueryOptions,
  getFaresQuery,
  getFaresQueryOptions,
} from '../../../features/patient-transport/queries';
import useLiveQuery from '../../../hooks/useLiveQuery';

export const Route = createFileRoute('/_auth/patient-transport/fares')({
  beforeLoad: ({ context }) => {
    const { user } = context.authenticationContext;
    const { healthCenterConfig } = context.healthCenterContext;

    // Cette section est spécifique au mode patient-transport
    if (user?.role !== 'PORTER' || !user?.porter) {
      throw redirect({
        to: '/login',
      });
    }

    // Vérifier que le healthCenter est configuré pour patient-transport
    if (!healthCenterConfig?.id) {
      throw redirect({ to: '/health-center-link' });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('patient-transport');
  const { pathname } = useLocation();
  const { user } = useAuthenticationContext();

  useLiveQuery(getFaresQuery(user?.porter));
  const { data: fares } = useSuspenseQuery(getFaresQueryOptions(user?.porter));
  const { data: dailyFares } = useSuspenseQuery(getDailyFaresQueryOptions());

  const activeTabValue = useMemo(
    () =>
      pathname.includes('/patient-transport/fares/active')
        ? '/patient-transport/fares/active'
        : pathname.includes('/patient-transport/fares/done')
          ? '/patient-transport/fares/done'
          : '/patient-transport/fares/active',
    [pathname]
  );

  return (
    <Stack>
      <Tabs value={activeTabValue} sx={{ paddingX: 1 }}>
        <Tab
          label={t('faresTabs.active', { count: fares?.length || 0 })}
          value="/patient-transport/fares/active"
          to="/patient-transport/fares/active"
          component={Link}
        />
        <Tab
          label={t('faresTabs.done', { count: dailyFares?.length || 0 })}
          value="/patient-transport/fares/done"
          to="/patient-transport/fares/done"
          component={Link}
        />
      </Tabs>
      <Outlet />
    </Stack>
  );
}
